import { Stack } from '@src/common/components/Stack';
import { theme } from '@src/common/styles/Theme';
import { FormDimensionInput } from '@src/orders/PermitFormSections/FormDimensionInput';
import { FormWeightInput } from '@src/orders/PermitFormSections/FormWeightInput';
import {
  TractorActualWeightField,
  TractorGroundHeightField,
  TractorGVWField,
  TractorHeightField,
  TractorLengthField,
  TractorOuterBridgeLengthField,
  TractorUnladenWeightField,
  TractorWheelBaseField,
  TractorWidthField,
} from '@src/permitField/TractorDimensionsFields';
import type { Control } from 'react-hook-form';

interface Props {
  control: Control;
}

export const TractorDimensionsForm = ({ control }: Props) => {
  return (
    <Stack direction="column" gap={theme.spacing['3']}>
      <FormDimensionInput
        control={control}
        fieldName={TractorLengthField.fieldName}
      />
      <FormDimensionInput
        control={control}
        fieldName={TractorWidthField.fieldName}
      />
      <FormDimensionInput
        control={control}
        fieldName={TractorHeightField.fieldName}
      />
      <FormDimensionInput
        control={control}
        fieldName={TractorWheelBaseField.fieldName}
      />
      <FormDimensionInput
        control={control}
        fieldName={TractorGroundHeightField.fieldName}
      />

      <FormWeightInput
        control={control}
        fieldName={TractorUnladenWeightField.fieldName}
        multiplyByThousand={true}
      />
      <FormWeightInput
        control={control}
        fieldName={TractorActualWeightField.fieldName}
        multiplyByThousand={true}
      />
      <FormWeightInput
        control={control}
        fieldName={TractorGVWField.fieldName}
        multiplyByThousand={true}
      />
      <FormDimensionInput
        control={control}
        fieldName={TractorOuterBridgeLengthField.fieldName}
      />
    </Stack>
  );
};
